import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DisplayEiaHighchartComponent } from './display-eia-highchart/display-eia-highchart.component';
import { DisplayEiaHighstockComponent } from './display-eia-highstock/display-eia-highstock.component';
import { DisplayEiaHighmapComponent } from './display-eia-highmap/display-eia-highmap.component';
import { DisplayEiaHeatmapComponent } from './display-eia-heatmap/display-eia-heatmap.component';
import { DisplayEiaParetoComponent } from './display-eia-pareto/display-eia-pareto.component';
import { GasConsumptionComponent } from './gas-consumption/gas-consumption.component';
import { DisplayStorageWeeklyWorkingComponent } from './display-storage-weekly-working/display-storage-weekly-working.component';
import { NuclearOutagesComponent } from './nuclear-outages/nuclear-outages.component';
import { DisplayWeeklyNetChangeComponent } from './display-weekly-net-change/display-weekly-net-change.component';
import { DisplayGasTradeDispositionComponent } from './display-gas-trade-disposition/display-gas-trade-disposition.component';
import { MapTemperatureDepartureFromNormalComponent } from './map-temperature-departure-from-normal/map-temperature-departure-from-normal.component';
import { MapDailyAnimationComponent } from './map-daily-animation/map-daily-animation.component';
import { NouisliderModule} from "ng2-nouislider";
import { SafeHtmlPipe } from './safe-html/safe-html.pipe';
import { DisplayHenryHubComponent } from './display-henry-hub/display-henry-hub.component';
import { MapLegendComponent } from './map-legend/map-legend.component';
import { DisplayEiaSingleDayStorageWithGaugesComponent } from './display-eia-single-day-storage-with-gauges/display-eia-single-day-storage-with-gauges.component';

declare var require: any;
@NgModule({
  imports: [
    CommonModule,
    NouisliderModule,
    FormsModule

  ],
  declarations: [
    DisplayEiaHighchartComponent, 
    DisplayEiaHighstockComponent, 
    DisplayEiaHighmapComponent,
    DisplayEiaHeatmapComponent,
    DisplayEiaParetoComponent,
    GasConsumptionComponent, 
    DisplayStorageWeeklyWorkingComponent,
    DisplayWeeklyNetChangeComponent,
    NuclearOutagesComponent,
    DisplayGasTradeDispositionComponent,
    MapTemperatureDepartureFromNormalComponent,
    MapDailyAnimationComponent,
    DisplayHenryHubComponent,
    SafeHtmlPipe,
    MapLegendComponent,
    DisplayEiaSingleDayStorageWithGaugesComponent
  ],
  exports: [
    DisplayEiaHighchartComponent, 
    DisplayEiaHighstockComponent, 
    DisplayEiaHighmapComponent,
    DisplayEiaHeatmapComponent,
    DisplayEiaParetoComponent,
    GasConsumptionComponent,
    DisplayStorageWeeklyWorkingComponent,
    DisplayWeeklyNetChangeComponent,
    NuclearOutagesComponent,
    DisplayGasTradeDispositionComponent,
    MapTemperatureDepartureFromNormalComponent,
    MapDailyAnimationComponent,
    DisplayHenryHubComponent,
    SafeHtmlPipe,
    MapLegendComponent,
    DisplayEiaSingleDayStorageWithGaugesComponent
  ]
})
export class EiaChartsModule { }



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/eia-charts.module.ts